import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const useRewriteUrl = () => {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (location.pathname.startsWith("/modules/")) {
      navigate(location.pathname.replace("/modules/", "/chuyen-muc/"), { replace: true });
    }
    if (location.pathname.startsWith("/p/")) {
      navigate(location.pathname.replace("/p/", "/tin/"), { replace: true });
    }
    if (location.pathname.startsWith("/nguoi-dung/")) {
      navigate(location.pathname.replace("/nguoi-dung/", "/thanh-vien/"), { replace: true });
    }
  }, [location, navigate]);
};

export default useRewriteUrl;
